import { useMemo } from 'react'

import type { RealtimeTransportIdentity } from '@repo/sdk'

import { canHoldStream } from './realtime-transport'

export const ROOM_POLL_INTERVAL_MS = 1_500

export const ROOM_STREAM_SAFETY_REFETCH_MS = 30_000

export const ROOM_TERMINAL_POLL_INTERVAL_MS = 5_000

export function roomRefetchIntervalMs(args: {
  streaming: boolean
  terminal: boolean
}): number {
  if (args.terminal)
    return ROOM_TERMINAL_POLL_INTERVAL_MS
  return args.streaming ? ROOM_STREAM_SAFETY_REFETCH_MS : ROOM_POLL_INTERVAL_MS
}

export function useRoomStreamEligibility(
  identity: RealtimeTransportIdentity | null | undefined,
  authResolved: boolean,
): boolean {
  return useMemo(
    () => canHoldStream(identity, authResolved),
    [identity, authResolved],
  )
}

export type StreamStatus = 'idle' | 'connecting' | 'error' | 'pending'

export function roomStreamDeliversUpdates(args: {
  eligible: boolean
  status: StreamStatus | undefined
}): boolean {
  return args.eligible && args.status === 'pending'
}

export const ROOM_CHAT_POLL_INTERVAL_MS = 5_000

export const ROOM_CHAT_STREAM_SAFETY_REFETCH_MS = 30_000

export function roomChatRefetchIntervalMs(args: {
  streaming: boolean
  open: boolean
}): number | false {
  if (!args.open)
    return false
  return args.streaming
    ? ROOM_CHAT_STREAM_SAFETY_REFETCH_MS
    : ROOM_CHAT_POLL_INTERVAL_MS
}
